import { useChatboxStore } from "../store";
import type { MessagingMessage } from "@/model/messaging";

export const useSiblingMessages = (message: MessagingMessage) => {
  const {
    use: { convertedMsgs },
  } = useChatboxStore();
  const index = convertedMsgs.findIndex((m) => m.uid === message.uid);
  if (index < 0) {
    return {
      prevMessage: undefined,
      nextMessage: undefined,
    };
  }

  return {
    prevMessage: convertedMsgs[index - 1],
    nextMessage: convertedMsgs[index + 1],
  };
};
